import { computed, inject, type Provider } from '@angular/core';
import {
  activeLocale,
  AvailableLocales,
  DefaultLocale,
  LANGUAGE_LOCALE_MAP,
} from '@app/+authenticated/shared/locale/locale.helper';
import { selectCurrency } from '@app/reducers/currency/currency.service';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { AppState } from '@reducers/interfaces';
import { FormattingContext } from '@sb/shared/formatting';

const LANGUAGE_TO_LOCALE: Record<string, string> = LANGUAGE_LOCALE_MAP;

// The selected language may be a bare code (`nl`) or a full tag (`nl-NL`);
// Intl needs the full tag.
const resolveLocale = (language: string): string => {
  if (AvailableLocales.includes(language)) {
    return language;
  }

  return LANGUAGE_TO_LOCALE[language] ?? DefaultLocale;
};

export const provideFormattingContext = (): Provider => ({
  provide: FormattingContext,
  useFactory: (): FormattingContext => {
    const store = inject<Store<AppState>>(Store);
    const translate = inject(TranslateService);

    return {
      locale: computed(() => resolveLocale(translate.currentLang() ?? activeLocale())),
      currency: store.selectSignal(selectCurrency),
    };
  },
});
